module.exports = __webpack_public_path__ + "media/temp/modiphius-95ac62e9.svg";